import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={24.392}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20376 19338"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#000}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528324060448">
        <path
          d="M4729 731c0-89 26-116 115-116h10765v6421H4729V731zm-615-308v3998H2230c-747 0-1112 137-1539 461C396 5106 0 5676 0 6190v6958c0 881 887 1769 1999 1769h500v-4306c0-292 310-423 615-423h14071c591 0 697 192 693 692l-1 3460c1 700-174 577 500 577 527 0 947-165 1325-482 390-326 674-848 674-1402V6305c0-531-271-1043-659-1378-392-340-811-506-1532-506h-1961V307c0-185-121-307-307-307H4460c-236 0-346 183-346 423z"
          className="fill"
        />
        <path
          d="M4729 18608v-6151h10880v6266H4844c-89 0-115-26-115-115zm-1961-7958c0 675-56 3821 39 4229 349 81 926 38 1307 38v3999c0 239 110 422 346 422h11457c186 0 307-121 307-307v-4114c386 0 994 43 1346-38v-4345c-86-20-89-38-193-38H2922c-90 0-154 63-154 154z"
          className="fill"
        />
        <path
          d="M6075 16301c0 90 63 154 153 154h7536c205 0 205-308 0-308H6228c-90 0-153 64-153 154zM6075 17608c0 119 112 154 230 154h7382c333 0 262-308 77-308H6228c-90 0-153 64-153 154zM6075 13687c0 118 112 154 230 154 627 0 3329 54 3729-39 39-166 69-250-151-271l-3770 2c-25 103-38 72-38 154zM6075 14994c0 90 63 154 153 154 634 0 3405 55 3806-39 29-121 68-269-115-269H6228c-90 0-153 64-153 154z"
          className="fill"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
